function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color-monochrome-mediumDark)",
  className: "robot_svg__fill",
  d: "M9 15a1 1 0 101 1 1 1 0 00-1-1zm-7-1a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm20 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-5-7h-4V5.72A2 2 0 0014 4a2 2 0 00-4 0 2 2 0 001 1.72V7H7a3 3 0 00-3 3v9a3 3 0 003 3h10a3 3 0 003-3v-9a3 3 0 00-3-3zm-3.28 2l-.5 2h-2.44l-.5-2zM18 19a1 1 0 01-1 1H7a1 1 0 01-1-1v-9a1 1 0 011-1h1.22L9 12.24a1 1 0 001 .76h4a1 1 0 001-.76L15.78 9H17a1 1 0 011 1zm-3-4a1 1 0 101 1 1 1 0 00-1-1z"
});

function SvgRobot(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default ForwardRef;